import { NormalIconProps } from 'assets/icons';
import React from 'react';

export const TvIcon: React.FC<NormalIconProps> = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" className={props.className} onClick={props.onClick} width="24" height="18" viewBox="0 0 512 413.809">
		<g transform="translate(-3 -4.727)">
			<path
				d="M452.581,15.97c24.906,7.251,44.169,27.676,50.452,53.525,16,47.769,15.915,237.517,0,283.153-6.283,25.85-25.546,46.273-50.452,53.527-44.754,16.742-342.437,16.216-387.161,0-24.41-6.864-43.534-26.348-50.454-51.4C-1,307.732-.975,117.292,14.966,70.575,21.249,44.7,40.484,24.3,65.42,17.049,110.144.8,407.827.8,452.581,15.97Z"
				transform="translate(0 0)"
				fill="#EE1313"
			/>
			<path
				d="M134.577,93.891,30.127,153.283a13.37,13.37,0,0,1-19.982-11.622V22.874A13.382,13.382,0,0,1,30.127,11.222L134.577,70.615A13.391,13.391,0,0,1,134.577,93.891Z"
				transform="translate(196.077 129.879)"
				fill="white"
			/>
		</g>
	</svg>
);
